import PropTypes from 'prop-types';
import {isValidEmail} from 'helpers/validation';

import React from 'react';

import {Creatable} from 'react-select';

import cloneDeep from 'lodash/cloneDeep';

import difference from 'lodash/difference';

import events from '../../../lib/events.js';

import phoneFormat from '../../../util/phoneformat.js';

import CustomerApi from '../../../api/customer.jsx';

import CustomerContactApi from '../../../api/customerContact.jsx';

import CustomerContact from '../../../models/customerContact.jsx';

import Loader from '../loader.jsx';

import {FormattedMessage} from 'react-intl';

const ALL = {
  value: 'All',
  label: 'All',
};

function newOptionCreator({label, labelKey, valueKey}) {
  const option = {};

  option[valueKey] = label;
  option[labelKey] = label;
  option.new = true;
  option.valid = isValidEmail(label);
  option.className = 'Select-create-option-placeholder';
  return option;
}

class EmailSelect extends React.Component {
  static propTypes = {
    customerID: PropTypes.number,
    onUpdate: PropTypes.func.isRequired,
    formatMessage: PropTypes.any,
  };

  state = {
    selected: [],
    options: [],
    active: null,
    activeEmailError: false,
    creating: false,
    editing: false,
    saved: false,
    saving: false,
  };

  componentWillMount() {
    if (this.props.customerID) {
      CustomerApi.getCustomer(this.props.customerID, false)
        .then(customer => {
          let contacts = cloneDeep(customer.customerContacts);

          for (let contact of contacts) {
            // Adding values used by react-select
            contact.value = `${contact.id}`;
            contact.label = (contact.nameFirst || '') + ' ' + (contact.nameLast || '');
            contact.label = contact.label.trim();
          }
          // ALL.selectedLabel = `All (${contacts.length})`;
          // ALL.optionLabel = `Send to all contacts (${contacts.length})`;
          // contacts.push(ALL);
          this.setState({options: contacts});
        });
    }
  }

  onChange = (selected) => {
    // Enusuring that selected and state.selected are always arrays
    selected = selected || [];
    // When adding an element, highlight that element
    let activeItem = null;

    if (selected.length > this.state.selected.length) {
      activeItem = difference(selected, this.state.selected)[0];
    }

    // Ensure that 'All' cannot be selected along with other values in a multiselect
    if (Array.isArray(selected) && Array.isArray(this.state.selected)) {
      let containsAll = this.state.selected.indexOf(ALL) > -1;
      let selectedAll = selected.indexOf(ALL) > -1;
      // Remove all other values when 'All' option is selected

      if (!containsAll && selectedAll) {
        // Only remove options with a contact so that custom email address stay
        selected = selected.filter(x => x && x.new).concat([ALL]);
        // Remove 'All' when another option is added unless it's a new contact
      } else if (selectedAll && selected.length > 1 && !activeItem.new) {
        selected = selected.filter(x => x.value !== 'All');
      }

      if (selectedAll) {
        let emails = selected.map(x => x.email || x.new && x.valid && x.label).filter(x => x);

        emails.push(...this.state.options.map(x => x.email).filter(x => x));
        this.props.onUpdate(emails);
      } else {
        this.props.onUpdate(selected.map(x => x.email || x.new && x.valid && x.label).filter(x => x));
      }
    }

    this.setState({
      active: activeItem,
      selected: selected,
      creating: false,
      editing: !activeItem || !activeItem.email,
      activeEmailError: !activeItem || !activeItem.email,
      saved: false,
    });

    this.props.onUpdate(
      selected.map((x) => {
        return {
          email: x.email || x.new && x.valid && x.label,
          firstName: x.nameFirst,
          lastName: x.nameLast,
        };
      }).filter(x => x)
    );
  };

  onValueClick = (item) => {
    this.setState({
      active: item,
      creating: false,
      editing: !item.email,
      activeEmailError: !item.email,
      saved: false,
    });
  };

  getEmailList = () => {
    return this.state.selected.map(x => x.email || x.new && x.valid && x.label).filter(x => x).join(', ');
  };

  activeItemDisplay = () => {
    if (!this.state.active) {
      return null;
    }

    if (this.state.active.value === 'All') {
      return (
        <div className='form-group'>
          <label><FormattedMessage id='general.email'/>:</label>
          <div>
            <span>{this.state.options.map(x => x.email).filter(x => x).join(', ')}</span>
          </div>
        </div>
      );
    }

    if (this.state.active.new && !this.state.active.valid) {
      return this.invalidEmail();
    }

    if (this.state.creating) {
      return this.creatingItem();
    }

    if (this.state.active.new) {
      return (
        <div className='form-group'>
          <label><FormattedMessage id='general.email'/>:</label>
          <div>
            {this.state.active.label}
            &nbsp;
            {this.props.customerID ?
              <a className='pointer underline dim'
                 onClick={this.create}><FormattedMessage id='general.create.contact'/></a> :
              null}
          </div>
        </div>
      );
    }

    if (this.state.editing) {
      return this.editingItem();
    }

    let saved;

    if (this.state.saved) {
      saved =
        <span className='blue'>
          &nbsp; <i className='bl bl-checkmark'></i> <FormattedMessage id='general.saved'/>!
        </span>
      ;
    }

    return (
      <div className='form-group'>
        <label><FormattedMessage id='general.email'/> ({this.state.active.label}):</label>
        <div>
          {this.state.active.email}
          &nbsp; <a className='pointer underline dim'
                    onClick={this.edit}><FormattedMessage id='general.edit'/></a>
          &nbsp; {saved}
        </div>
      </div>
    );
  };

  cancel = () => {
    this.setState({active: null, creating: false, editing: false});
  };

  create = () => {
    this.setState({creating: true});
  };

  createContact = (event) => {
    event.preventDefault();
    this.setState({saving: true});
    let active = this.state.active;

    active.new = false;
    active.label = this.refs.nameFirst.value + ' ' + this.refs.nameLast.value;
    active.email = active.value;

    let customerContact = new CustomerContact({
      customerID: this.props.customerID,
      nameFirst: this.refs.nameFirst.value,
      nameLast: this.refs.nameLast.value,
      homePhone: this.refs.phone.value,
      email: active.value,
    });

    // Adding values used by react-select
    customerContact.value = active.value;
    customerContact.label = customerContact.nameFirst + ' ' + customerContact.nameLast;

    CustomerContactApi.save(customerContact)
      .then(() => {
        let options = this.state.options;

        options.push(customerContact);
        this.setState({
          active: active,
          creating: false,
          editing: false,
          options: options,
          saved: true,
          saving: false,
        });
        events.publish('customer-change', null);
      })
      .catch(e => console.error(e));
  };

  creatingItem = () => {
    let {formatMessage} = this.props;

    return (
      <div className='row'
           style={{minHeight: '50px'}}>
        <Loader loaded={!this.state.saving}>
          <form onSubmit={this.createContact}>
            <div className='col-md-6'>
              <div className='form-group'>
                <input type='text'
                       className='form-control'
                       ref='nameFirst'
                       placeholder={formatMessage({id: 'general.first.name'})}
                       required
                       autoFocus/>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <input type='text'
                       className='form-control'
                       ref='nameLast'
                       placeholder={formatMessage({id: 'general.last.name'})}
                       required/>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <input type='text'
                       className='form-control'
                       ref='organization'
                       placeholder={formatMessage({id: 'customer.organization'})}/>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='form-group'>
                <input type='text'
                       className='form-control'
                       ref='phone'
                       placeholder={formatMessage({id: 'general.phone.number'})}
                       maxLength='20'
                       required
                       pattern='\([0-9]{3}\)\ [0-9]{3}\-[0-9]{4}'
                       title={formatMessage({id: 'general.phone.validation'})}
                       onChange={event => event.target.value = phoneFormat(event.target.value)}/>
              </div>
            </div>
            <div className='col-md-3 col-md-offset-9'>
              <button type='submit'
                      className='button-link underline b'><FormattedMessage id='general.save'/></button>
              &nbsp;|&nbsp;
              <a className='pointer underline dim'
                 onClick={this.cancel}><FormattedMessage id='general.cancel'/></a>
            </div>
          </form>
        </Loader>
      </div>
    );
  };

  edit = () => {
    this.setState({editing: true});
  };

  editInvalidEmail = (event) => {
    event.preventDefault();
    if (this.state.activeEmailError) {
      return;
    }
    let active = this.state.active;

    active.valid = true;
    active.value = this.refs.email.value;
    active.label = this.refs.email.value;
    this.setState({active: active});
    this.props.onUpdate(this.state.selected.map(x => x.email || x.new && x.valid && x.label).filter(x => x));
  };

  editingItem = () => {
    return (
      <div className='row'
           style={{minHeight: '50px'}}>
        <Loader loaded={!this.state.saving}>
          <div className='col-md-6'>
            <div className='form-group'>
              <label><FormattedMessage id='general.email'/> ({this.state.active.label}):</label>
              <input type='email'
                     className={this.state.activeEmailError ? 'form-control error' : 'form-control'}
                     style={{marginTop: '0px'}}
                     ref='email'
                     placeholder={this.props.formatMessage({id: 'email.enter.placeholder'})}
                     onChange={this.emailChange}
                     defaultValue={this.state.active.email}/>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='form-group'
                 style={{marginTop: '4px'}}>
              <div>
                <label>&nbsp;</label>
              </div>
              <a className='pointer underline b'
                 onClick={this.save}><FormattedMessage id='general.save'/></a>
              &nbsp;|&nbsp;
              <a className='pointer underline dim'
                 onClick={this.cancel}><FormattedMessage id='general.cancel'/></a>
            </div>
          </div>
        </Loader>
      </div>
    );
  };

  emailChange = () => {
    this.setState({activeEmailError: !isValidEmail(this.refs.email.value)});
  };

  invalidEmail = () => {
    return (
      <div className='row'
           style={{minHeight: '50px'}}>
        <Loader loaded={!this.state.saving}>
          <div className='col-md-6'>
            <div className='form-group'>
              <label><FormattedMessage id='general.email'/> ({this.state.active.label}):</label>
              <input type='email'
                     className={this.state.activeEmailError ? 'form-control error' : 'form-control'}
                     style={{marginTop: '0px'}}
                     ref='email'
                     placeholder={this.props.formatMessage({id: 'email.enter.placeholder'})}
                     onChange={this.emailChange}
                     defaultValue={this.state.active.label}/>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='form-group'
                 style={{marginTop: '4px'}}>
              <div>
                <label>&nbsp;</label>
              </div>
              <a className='pointer underline b'
                 onClick={this.editInvalidEmail}><FormattedMessage id='general.save'/></a>
              &nbsp;|&nbsp;
              <a className='pointer underline dim'
                 onClick={this.cancel}><FormattedMessage id='general.cancel'/></a>
            </div>
          </div>
        </Loader>
      </div>
    );
  };

  optionRenderer = (item) => {
    if (item.optionLabel) {
      return item.optionLabel;
    }
    return (
      <div>
        {item.label}
        <i className='pull-right dim'>{item.email || this.props.formatMessage({id: 'email.add.email'})}</i>
      </div>
    );
  };

  save = (event) => {
    event.preventDefault();
    if (!this.refs.email.value) {
      return;
    }
    this.setState({saving: true});
    let options = this.state.options;
    let index = options.findIndex(x => x.value === this.state.active.value);

    options[index].email = this.refs.email.value;
    CustomerContactApi.save(options[index])
      .then(() => {
        this.setState({
          options: options,
          editing: false,
          saved: true,
          saving: false,
        });
        events.publish('customer-change', null);
        this.props.onUpdate(
          this.state.selected.map((x) => {
            return {
              email: x.email || x.new && x.valid && x.label,
              firstName: x.nameFirst,
              lastName: x.nameLast,
            };
          }).filter(x => x)
        );
      })
      .catch(e => console.error(e));
  };

  valueRenderer = (item) => {
    // Bold the selected item
    var className = '';

    if (item && this.state.active &&
      item.label === this.state.active.label &&
      item.value === this.state.active.value) {
      className = 'b';
    }

    // All has different display text in the options and when selected
    if (item.selectedLabel) {
      return <span className={className}>{item.selectedLabel}</span>;
    }

    // Show error on contacts with no email
    if (!item.email && !item.new) {
      return <span className={className}>{item.label} <i className='bl bl-attention red'
                                                         style={{verticalAlign: 'middle'}}/></span>;
    }

    // Show error on invalid emails
    if (item.new && !item.valid) {
      return <span className={className}>{item.label} <i className='bl bl-attention red'
                                                         style={{verticalAlign: 'middle'}}/></span>;
    }

    return <span className={className}>{item.label}</span>;
  };

  render() {
    return (
      <div className='row'>
        <div className='col-md-6'>
          <div className='form-group'>
            <label><FormattedMessage id='email.send.to'/>:</label>
            <Creatable
              name='email'
              multi
              placeholder={this.props.formatMessage({id: 'email.select.contact'})}
              options={this.state.options}
              value={this.state.selected}
              onValueClick={this.onValueClick}
              optionRenderer={this.optionRenderer}
              valueRenderer={this.valueRenderer}
              newOptionCreator={newOptionCreator}
              onChange={this.onChange}/>
          </div>
        </div>
        <div className='col-md-6'>
          {this.activeItemDisplay()}
        </div>
      </div>
    );
  }
}

export default EmailSelect;
